import Store from './redux/store';
import Layout from './react/components/layouts/AfspLayout';
import SessionActions from './redux/actions/sessionActions';
import SessionReducers from './redux/reducers/sessionReducers';
import SessionServices from './redux/services/sessionServices';
import WindowActions from './redux/actions/windowActions';
import WindowReducers from './redux/reducers/windowReducers';
import WindowServices from './redux/services/windowServices';
import * as esGeneralAfspUtils from './utils/generalUtils';
import * as esProviderUtils from './utils/providerUtils';

export { default as AfspLayout } from './react/components/layouts/AfspLayout';
export { default as Help } from './react/components/Help';
export { default as AfspMenu } from './react/components/AfspMenu';
export { default as AfspLoginReducers } from './redux/reducers/afspLoginReducers';
export { default as AfspLoginServices } from './redux/services/afspLoginServices';

export const
generalAfspUtils = esGeneralAfspUtils,
providerUtils = esProviderUtils,
AfspReact = { Layout },
AfspRedux = {
    Store: Store,
    Window: {
        Reducers: SessionReducers,
        Actions: WindowActions,
        Services: WindowServices
    },
    Session: {
        Reducers: WindowReducers,
        Actions: SessionActions,
        Services: SessionServices
    }
}